import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Wallet18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path d='M12.25 10V13H13.75V10H12.25Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.8101 1.02313L15.4606 6.25H16.75V15.5C16.75 16.1904 16.1904 16.75 15.5 16.75H4C2.48122 16.75 1.25 15.5188 1.25 14V5C1.25 3.48122 2.48122 2.25 4 2.25H10.6948L12.8101 1.02313ZM2.75 7.45015V14C2.75 14.6904 3.30964 15.25 4 15.25H15.25V7.75H4C3.54989 7.75 3.12503 7.64186 2.75 7.45015ZM3.8204 6.23719C3.21514 6.15011 2.75 5.62937 2.75 5C2.75 4.30964 3.30964 3.75 4 3.75H8.10862L3.8204 6.23719ZM6.78803 6.25H13.7788L12.19 3.11685L6.78803 6.25Z'
      fill='currentColor'
    />
  </Svg>
);

Wallet18.displayName = 'Wallet18';
export default Wallet18;
